// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { Entity, EntityT } from '../tbs/entity.js';


export class PaintTileOption implements flatbuffers.IUnpackableObject<PaintTileOptionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PaintTileOption {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPaintTileOption(bb:flatbuffers.ByteBuffer, obj?:PaintTileOption):PaintTileOption {
  return (obj || new PaintTileOption()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPaintTileOption(bb:flatbuffers.ByteBuffer, obj?:PaintTileOption):PaintTileOption {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PaintTileOption()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

dname():string|null
dname(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dname(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

entity(obj?:Entity):Entity|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new Entity()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

assignSelectedPlayer():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

folderId():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

static startPaintTileOption(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addDname(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, dnameOffset, 0);
}

static addEntity(builder:flatbuffers.Builder, entityOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, entityOffset, 0);
}

static addAssignSelectedPlayer(builder:flatbuffers.Builder, assignSelectedPlayer:boolean) {
  builder.addFieldInt8(2, +assignSelectedPlayer, +false);
}

static addFolderId(builder:flatbuffers.Builder, folderId:number) {
  builder.addFieldInt32(3, folderId, 0);
}

static endPaintTileOption(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): PaintTileOptionT {
  return new PaintTileOptionT(
    this.dname(),
    (this.entity() !== null ? this.entity()!.unpack() : null),
    this.assignSelectedPlayer(),
    this.folderId()
  );
}


unpackTo(_o: PaintTileOptionT): void {
  _o.dname = this.dname();
  _o.entity = (this.entity() !== null ? this.entity()!.unpack() : null);
  _o.assignSelectedPlayer = this.assignSelectedPlayer();
  _o.folderId = this.folderId();
}
}

export class PaintTileOptionT implements flatbuffers.IGeneratedObject {
constructor(
  public dname: string|Uint8Array|null = null,
  public entity: EntityT|null = null,
  public assignSelectedPlayer: boolean = false,
  public folderId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const dname = (this.dname !== null ? builder.createString(this.dname!) : 0);
  const entity = (this.entity !== null ? this.entity!.pack(builder) : 0);

  PaintTileOption.startPaintTileOption(builder);
  PaintTileOption.addDname(builder, dname);
  PaintTileOption.addEntity(builder, entity);
  PaintTileOption.addAssignSelectedPlayer(builder, this.assignSelectedPlayer);
  PaintTileOption.addFolderId(builder, this.folderId);

  return PaintTileOption.endPaintTileOption(builder);
}
}
